var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.connected)?_c('div',{staticClass:"deconnection"},[_c('h1',[_vm._v("Déconnexion")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }